import ListItemText from '@mui/material/ListItemText';

export { ListItemText };
